import React from 'react';
import PremierPackage from './PremierPackage';
import BrokeragePackage from './BrokeragePackage';

const PackageComparison = () => {
	return (
		<div className='w-full mx-[auto] bg-[#F3F3F3]'>
			<div className='max-w-[1180px] mx-auto w-full px-[20px]'>
				<h3 className='font-canela-trial text-[35px] sm:text-[35px] text-[28px] pt-6 pb-3 mb-[35px] font-bold leading-[42px] sm:leading-[42px] leading-[34px] text-center text-clientBlack smallView:text-[24px] smallView:leading-[30px]'>
					Choose Your Marketing Package
				</h3>

				{/* Package comparison table header */}
				<div className='hidden md:flex justify-between mb-6 px-4'>
					<div className='w-1/2 text-center'>
						<h4 className='font-canela-trial text-[22px] font-medium uppercase text-clientBlack'>
							For Individual Agents
						</h4>
					</div>
					<div className='w-1/2 text-center'>
						<h4 className='font-canela-trial text-[22px] font-medium uppercase text-clientBlack'>
							For Brokerages and Teams
						</h4>
					</div>
				</div>
			</div>

			{/* Packages section with improved visual comparison */}
			<div className='bg-[#1E1E1E] mx-auto w-full md:mt-[280px] px-[30px] sm:px-[30px] px-[15px] md:pt-0 pt-[30px]'>
				<div className='flex justify-center md:flex-row flex-col mx-auto w-[fit-content] max-w-[1180px]'>
					<PremierPackage />
					<BrokeragePackage />
				</div>
			</div>
		</div>
	);
};

export default PackageComparison;
